/** @namespace Reducers.policies */

import { IDS as PNP_ACCRED_ACTION_IDS } from '../components/policies/pnp-accred/pnp-accred-action-id.constants';
import { PREFIX as PNP_ACCRED_ACTION_PREFIX } from '../components/policies/pnp-accred/pnp-accred-action-type.constants';
import { PnpAccredReducer } from '../components/policies/pnp-accred/pnp-accred.reducer';
import { pnpAccredTabs } from "../components/policies/pnp-accred/pnp-accred-tabs";
import * as TYPE from '../components/policies/pnp.actions.types';
import { GridReducer } from '../common/grid/grid.reducer';
import { getGridSort } from '../common/grid/grid.utils';
import { tabs } from '../components/policies/pnp.tabs';
import pnpReducer from '../components/policies/pnp.reducer';
import { TabsResolver } from '../common/tabs/tabs.resolver';
import { DATE_FORMAT } from '../common/utils/util.constants';
import moment from 'moment';
import { get, merge, set } from 'lodash';
import { getSelectedRiskLevel , getSelectedPrefixName} from '../components/policies/pnp.utils';

const initialState = {
    ...pnpReducer
};

/**
 * @function policiesReducer
 * @param state {object}
 * @param action {object}
 * @returns {object} Redux Store
 * @memberOf Reducers
 */
export default (state = initialState, action) => {

    if (typeof state === 'undefined') {
        return {
            pnpAccred: PnpAccredReducer(),
            simpleSectionsTree: [],
            selectCascadeStandard: {
                level1Standards: [],
                level2Standards: [],
                level3Standards: [],
                level1StandardId: null,
                level2StandardId: null,
                level3StandardId: null,
            },
            ...pnpAccredTabs
        };
    }

    if (Object.keys(tabs).includes(action.id)) {
        return TabsResolver(state, action);
    }

    switch (action.type) {
        case TYPE.PNP_DOCUMENT_TYPE_RESET:
            return {
                ...state,
                pnpSettingsDocumentType: {
                    id: null,
                    name: null,
                    code: null,
                    contractTypeName: null,
                    shortName: null,
                    description: null,
                },
            }
        case TYPE.PNP_DOCUMENT_CATEGORY_DETAILS:
            if (['pnpSettingsDocumentCategory'].includes(action.id)) {
                return {
                    ...state,
                    pnpSettingsDocumentCategory: {
                        ...state.pnpSettingsDocumentCategory,
                        id: action.data.dca_id,
                        locations: action.locations,
                        name: { value: action.data.name , label: action.data.name } ,
                        location: action.data.loc_id,
                        locationName: action.data.location_name,
                        cat_num: action.data.cat_num,
                        defaultCategories: action.data.defaultCategories,
                        prefix: action.data.prefix
                    }
                }
            }
        case TYPE.PNP_DOCUMENT_CATEGORY_RESET:
            return {
                ...state,
                pnpSettingsDocumentCategory: {
                    id: null,
                    name: null,
                    location: null,
                    locationName: null,
                    cat_num: null,
                    locations: [],
                    defaultCategories: [],
                    prefix: null
                },
            }

        case TYPE.PNP_SETTINGS_APPROVAL_WORKFLOW_DETAILS:
            if (action.id === 'pnpSettingsApprovalWorkflow') {
                return {
                    ...state,
                    pnpSettingsApprovalWorkflow: {
                        ...state.pnpSettingsApprovalWorkflow,
                        id: action.data.id,
                        documentRiskLevel: action.data.document_risk_level ? action.data.document_risk_level.split(","): [],
                        documentCategory: action.data.id,
                        documentAuditType: action.data.document_audit_type,
                        documentContainerType: action.data.document_container_type,
                        selectedReviewer: null,
                        selectedReviewers: (action.data.reviewers) ? JSON.parse(action.data.reviewers) : [],
                        selectedApprover: null,
                        selectedApprovers: (action.data.approvers) ? JSON.parse(action.data.approvers) : [],
                        documentGroupUUID: action.data.group_uuid
                    }
                }
            }
        case TYPE.PNP_SETTINGS_APPROVAL_WORKFLOW_RESET:
            return {
                ...state,
                pnpSettingsApprovalWorkflow: {
                    id: null,
                    riskDuration: null,
                    documentRiskLevel: null,
                    documentCategory: null,
                    documentAuditType: null,
                    documentContainerType: null,
                    documentAuditTypes: state.pnpSettingsApprovalWorkflow.documentAuditTypes ?? [],
                    documentContainerTypes: state.pnpSettingsApprovalWorkflow.documenContainerTypes ?? [],
                    documentCategories: state.pnpSettingsApprovalWorkflow.documentCategories ?? [],
                    documentRiskLevels: state.pnpSettingsApprovalWorkflow.documentRiskLevels ?? [],
                    selectedReviewer: null,
                    selectedReviewers: [],
                    selectedApprover: null,
                    selectedApprovers: [],
                    documentGroupUUID: null
                },
            }
        case TYPE.PNP_DOCUMENT_DETAILS:
            if (['pnpDocument', 'pnpDocumentHistory'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        id: action.data.id,
                        title: action.data.title,
                        version: (action.updateVersion) ? (Number(action.data.version) + 1).toFixed(1) : action.data.version,
                        docNum: action.data.doc_num,
                        documentType: action.data.document_type,
                        documentTypeName:action.data.document_type_name,
                        documentCategory: action.data.document_category,
                        documentCategoryName:action.data.document_category_name,
                        docStatus: action.data.doc_status,
                        documentRiskLevel: action.data.document_risk_level,
                        documentApplicationType: action.data.document_application_type,
                        dueDate: action.data.due_date ? moment(action.data.due_date).format(DATE_FORMAT.INPUT) : null,
                        path: action.data.path,
                        pdfPath: action.data.pdf_path,
                        location: action.data.location,
                        locationName: action.data.location_name,
                        accountId: action.data.accountId,
                        locations: action.locations,
                        prefixName: (state.pnpDocument.documentCategories.length > 0) ? getSelectedPrefixName(action.data.document_category,state.pnpDocument.documentCategories ) : '',
                        riskDuration: (state.pnpDocument.documentRiskLevels.length > 0) ? getSelectedRiskLevel(action.data.document_risk_level, state.pnpDocument.documentRiskLevels) : '',
                        comment: action.data.comment ? JSON.parse(action.data.comment) : [],
                        author: action.data.author,
                        createdDate: action.data.created_date ? moment(action.data.created_date).format(DATE_FORMAT.INPUT) : null,
                        reviewId: action.data.review_id,
                        reviewType: action.data.review_type,
                        vdoId: action.data.vdo_id,
                        documentAccreditationSchemes:action.data.documentAccreditationSchemes,
                        selectdocumentAccreditationSchemes:action.data.selectdocumentAccreditationSchemes,
                        documentAccreditationSection:action.data.documentAccreditationSection,
                        downloadAllowed: action.data.download_allowed,
                        selectCascadeStandard: {
                        ...state.pnpDocument.selectCascadeStandard,
                        ...(action.data.selectCascadeStandard || {}), // Merge updates from action
                         // Optionally reset lower levels when a higher-level ID changes
                         ...(action.data.level1StandardId
                        ? {
                            level2Standards: [],
                            level3Standards: [],
                            level2StandardId: null,
                            level3StandardId: null
                          }
                        : {}),
                        ...(action.data.level2StandardId
                        ? {
                            level3Standards: [],
                            level3StandardId: null
                          }
                        : {}),
                     },
                    },
                }
            }
        case TYPE.PNP_DOCUMENT_REVIEWER_APPROVER_DETAILS:
            if (action.id === 'pnpDocument') {
                return {
                    ...state,
                    pnpDocument: {
                        ...state.pnpDocument,
                        selectedReviewers: action.data.reviewers,
                        selectedApprovers: action.data.approvers
                    }
                }
            }
        case TYPE.PNP_DOCUMENT_RESET:
            return {
                ...state,
                pnpDocument: {
                    id: null,
                    title: null,
                    version: '1.0',
                    docNum: null,
                    documentType: null,
                    documentRiskLevel: null,
                    documentApplicationType: null,
                    dueDate: null,
                    documentCategory: null,
                    docStatus: null,
                    path: null,
                    pdfPath: null,
                    location: null,
                    locationName: null,
                    accountId: null,
                    riskDuration: null,
                    prefixName: null,
                    reviewApproverTypes: null,
                    siteLocation: null,
                    headOffice: null,
                    selectedReviewer: null,
                    selectedReviewers: [],
                    selectedApprover: null,
                    selectedApprovers: [],
                    locations: [],
                    documentTypes: state.pnpDocument.documentTypes ?? [],
                    documentCategories: state.pnpDocument.documentCategories ?? [],
                    documentRiskLevels: state.pnpDocument.documentRiskLevels ?? [],
                    documentApplicationTypes: state.pnpDocument.documentApplicationTypes ?? [],
                    autocompleteReviewers: [],
                    autocompleteApprovers: [],
                    documentStatuses: state.pnpDocument.documentStatuses ?? [],
                    documentAccreditationSchemes:state.pnpDocument.documentAccreditationSchemes,
                    documentAccreditationSection: state.pnpDocument.documentAccreditationSection,
                    selectCascadeStandard: {
                        level1Standards: state.pnpDocument.selectCascadeStandard.level1Standards,
                        level2Standards: state.pnpDocument.selectCascadeStandard.level2Standards,
                        level3Standards: state.pnpDocument.selectCascadeStandard.level3Standards,
                        level1StandardId: null,
                        level2StandardId: null,
                        level3StandardId: null,
                    },
                    comment: null
                },
            }
        case TYPE.PNP_DOCUMENT_TYPES:
            if (action.id === 'pnpDocument') {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        documentTypes: action.items
                    }
                }
            }
        case TYPE.PNP_DOCUMENT_CATEGORIES:
            if (['pnpDocument', 'pnpSettingsApprovalWorkflow'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        documentCategories: action.items,
                        prefixName: getSelectedPrefixName(state.pnpDocument.documentCategory, action.items),
                    }
                }
            }
        case TYPE.PNP_DEFAULT_CATEGORIES:
            if (['pnpSettingsDocumentCategory'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        defaultCategories: action.items                    }
                }
            }
        case TYPE.PNP_DOCUMENT_RISK_LEVELS:
            if (['pnpDocument', 'pnpSettingsApprovalWorkflow'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        documentRiskLevels: action.items,
                        riskDuration: getSelectedRiskLevel(state.pnpDocument.documentRiskLevel, action.items)
                    }
                }
            }
        case TYPE.PNP_DOCUMENT_STATUSES:
            if (['pnpDocument', 'pnpSettingsApprovalWorkflow'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        documentStatuses: action.items
                    }
                }
            }
        case TYPE.PNP_DOCUMENT_APPLICATION_TYPES:
            if (['pnpDocument', 'pnpSettingsApprovalWorkflow'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        documentApplicationTypes: action.items
                    }
                }
            }
        case TYPE.PNP_AUDIT_TYPES:
            if (action.id === 'pnpSettingsApprovalWorkflow') {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        documentAuditTypes: action.items
                    }
                }
            }
        case TYPE.PNP_CONTAINER_TYPES:
            if (action.id === 'pnpSettingsApprovalWorkflow') {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        documentContainerTypes: action.items
                    }
                }
            }
        case TYPE.PNP_REVIEWERS_APPROVERS_TYPES:
            if (action.id === 'pnpDocument') {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        reviewApproverTypes: action.reviewApproverTypes,
                        autocompleteReviewers: [],
                        autocompleteApprovers: []
                    }
                }
            }
        case TYPE.PNP_REVIEWERS_CONTACTS:
            if (action.id === 'pnpDocument') {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        autocompleteReviewers: action.autocompleteReviewers
                    }
                }
            }
        case TYPE.PNP_ADD_REVIEWERS_CONTACTS:
            if (['pnpDocument', 'pnpSettingsApprovalWorkflow'].includes(action.id)) {
                state = set({ ...state }, action.path, get(state, action.path).concat([action.item]))
                return merge(state, { [action.id]: {
                    selectedReviewer: null
                }});
            }
        case TYPE.PNP_REMOVE_REVIEWERS_CONTACTS:
            return set({ ...state }, action.path, get(state, action.path).filter(
                item => item !== action.item
            ));
        case TYPE.PNP_APPROVERS_CONTACTS:
            if (action.id === 'pnpDocument') {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        autocompleteApprovers: action.autocompleteApprovers
                    }
                }
            }
        case TYPE.PNP_ADD_APPROVERS_CONTACTS:
            if (['pnpDocument', 'pnpSettingsApprovalWorkflow'].includes(action.id)) {
                state = set({ ...state }, action.path, get(state, action.path).concat([action.item]))
                return merge(state, { [action.id]: {
                    selectedApprover: null
                }});
            }
        case TYPE.PNP_REMOVE_APPROVERS_CONTACTS:
            return set({ ...state }, action.path, get(state, action.path).filter(
                item => item !== action.item
            ));
        case TYPE.PNP_ACCREDITATION_SCHEMES:
            if (['pnpDocument'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        documentAccreditationSchemes: action.items
                    }
                }
            }
        case TYPE.PNP_ACCREDITATION_SECTION:
            if (['pnpDocument'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        documentAccreditationSection: action.items
                    }
                }
            }
        case TYPE.PNP_SELECT_CASCADE_STANDARD:
            if (['pnpDocument'].includes(action.id)) {
                let component = 'pnpDocument';
                let componentState = state[component] || {};
                let selectCascadeStandard = componentState.selectCascadeStandard || {};
                if (action.level < 3) {
                    set(selectCascadeStandard,
                        `level${action.level + 1}Standards`,
                        action.standards.length === 0 ? [{value:0, label:''}] : action.standards.map(item => ({
                            value: item.id,
                            label: item.name,
                        }))
                    )
                }
                if (action.level === 1) {
                    set(selectCascadeStandard,
                        `level3Standards`,
                        action.level3Standards.length === 0 ? [{value:0, label:''}] : action.level3Standards.map(item => ({
                            value: item.id,
                            label: item.name,
                        }))
                    )
                }
                // remove reset value -1 which is avoiding drop down menu automatically pick first item
                if(selectCascadeStandard.level1StandardId === -1)
                    selectCascadeStandard.level1StandardId = null;
                if(selectCascadeStandard.level2StandardId === -1)
                    selectCascadeStandard.level2StandardId = null;
                if(selectCascadeStandard.level3StandardId === -1)
                    selectCascadeStandard.level3StandardId = null;

                // Set the updated selectCascadeStandard back to componentState
                componentState.selectCascadeStandard = selectCascadeStandard;

                // Update state with the new componentState
                state[component] = componentState;

                // Return the updated state
                return { ...state };
            }
        case TYPE.PNP_SELECT_CASCADE_STANDARD_RESET:
                if (['pnpDocument'].includes(action.id)) {
                    let component = 'pnpDocument';
                    let componentState = state[component] || {};
                    let selectCascadeStandard = componentState.selectCascadeStandard || {};
                    return {
                        ...state,
                        [component]: {
                            ...componentState,
                            selectCascadeStandard: {
                                ...selectCascadeStandard,
                                level1StandardId: -1,
                                level2StandardId: -1,
                                level3StandardId: -1,
                            },
                        },
                    };
        }

        case TYPE.PNP_ACCREDITATION_DETAILS_ID:
                if(['pnpDocumentAccreditationGrid'].includes(action.id)){
                    return {
                        ...state,
                       pnpDocumentAccreditationGrid: { // Update only the pnpDocumentAccreditationGrid part
                        ...state.pnpDocumentAccreditationGrid,  // Spread the existing grid data
                       filter: {
                        ...state.pnpDocumentAccreditationGrid.filter, // Spread the current filter
                        id: action.accreditationid, // Update the id in the filter
                         },
                       },
                    };
                }

        case TYPE.PNP_HISTORY_DETAILS_ID:
            if(['pnpDocumentHistoryGrid'].includes(action.id)){
                return {
                   ...state,
                    pnpDocumentHistoryGrid: { // Update only the pnpDocumentHistoryGrid part
                       ...state.pnpDocumentHistoryGrid,  // Spread the existing grid data
                       filter: {
                        ...state.pnpDocumentHistoryGrid.filter, // Spread the current filter
                        id: action.documentid, // Update the id in the filter
                         },
                       },
                    };
            }

        // case TYPE.PNP_UPDATE_DOCUMENT_STATUS:
        case 'INPUT_SELECT':
            if (['pnpSettingsDocumentCategory', 'pnpDocument', 'pnpSettingsApprovalWorkflow'].includes(action.id)) {
                const updatedState = {
                    ...state,
                    [action.id]: {
                      ...state[action.id],
                      [action.path]: action.input
                    }
                  };
                  if (action.path === 'documentRiskLevel') {
                    updatedState[action.id].riskDuration = getSelectedRiskLevel(
                      action.input,
                      state[action.id].documentRiskLevels
                    );
                  }
                  if (action.path === 'documentCategory') {
                    updatedState[action.id].prefixName = getSelectedPrefixName(
                      action.input,
                      state[action.id].documentCategories
                    );
                  }
                  return updatedState;
            }

            if (['pnpDocumentGrid', 'pnpComplianceReportGrid', 'pnpSettingsApprovalWorkflowGrid', 'pnpDocumentApprovalGrid', 'pnpDocumentAccreditationGrid', 'pnpDocSectionsGrid', 'pnpDocumentEventActionsGrid'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: set(GridReducer(state[action.id], { type: 'PAGINATE' }), action.path, action.input)
                }
            }
        case 'INPUT_TEXT_CHANGE': {
            const { id, path, input } = action;

            const fieldTransformations = {
                pnpSettingsApprovalWorkflow: (val) => val,
                pnpDocument: (val) => val,
                pnpSettingsDocumentCategory: (val, path) =>
                    path === 'prefix' ? val.toUpperCase() : val
            };

            const gridIds = [
                'pnpDocumentGrid',
                'pnpComplianceReportGrid',
                'pnpSettingsApprovalWorkflowGrid',
                'pnpDocumentApprovalGrid'
            ];

            if (fieldTransformations[id]) {
                return {
                    ...state,
                    [id]: {
                        ...state[id],
                        [path]: fieldTransformations[id](input, path)
                    }
                };
            }

            if (gridIds.includes(id)) {
                return {
                    ...state,
                    [id]: set(GridReducer(state[id], { type: 'PAGINATE' }), path, input)
                };
            }

            return state;
        }
        case 'INPUT_TEXT_AREA_CHANGE':
            if (['pnpSettingsDocumentCategory', 'pnpDocument', 'pnpSettingsApprovalWorkflow'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        [action.path]: action.input
                    }
                }
            }
        case 'LOCATION_SELECTED':
            if(['pnpDocument','pnpSettingsDocumentCategory'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: {
                        ...state[action.id],
                        location: action.uuid,
                        locationName: action.locationName,
                        accountId: action.accountId
                    }
                }
            }
            if (['pnpDocumentGrid', 'pnpComplianceReportGrid', 'pnpDocumentApprovalGrid'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: set(GridReducer(state[action.id], { type: 'PAGINATE' }), action.path, action.uuid)
                };
            }
        case 'INPUT_RADIO_CHANGE':
        case 'INPUT_EMAIL_CHANGE':
        case 'INPUT_PHONE_CHANGE':
        case 'DATE_SELECTED':
        case 'CHECKBOX_SELECTED':
        case 'RM_WIPE_TEST_CALCULATE_RESULT':
        case 'RM_WIPE_TEST_CALCULATE_DIFFERENCE':
        case 'INPUT_SIGNATURE':
        case 'AUTOCOMPLETE_SELECTED':
            if (['pnpDocument', 'pnpSettingsApprovalWorkflow'].includes(action.id) && action.item) {
                return set({ ...state }, action.path, action.item)
            }
            if(['pnpSettingsDocumentCategory'].includes(action.id) && action.item){
                const newValue = typeof action.item === 'string'
                ? { value: action.item, label: action.item }
                : action.item;
                const updatedPath = `${action.id}.${action.path}`;
                return set({ ...state }, updatedPath, newValue);
            }
            if (['pnpDocumentGrid', 'pnpComplianceReportGrid', 'pnpDocumentApprovalGrid'].includes(action.id)) {
                return {
                    ...state,
                    [action.id]: set(GridReducer(state[action.id], { type: 'PAGINATE' }), action.path, action.input)
                }
            }
        case 'GRID_INIT':
        case 'GRID_RESET':
            const pcGrid = GridReducer(state[action.id], action);
            return {
                ...state,
                [action.id]: {
                    ...pcGrid,
                    filter: {
                        ...pcGrid.filter,
                        keyword: null,
                        documentStatus: null,
                        documentCategory: null,
                        documentType: null,
                        createdDateFrom: null,
                        createdDateTo: null,
                        location: null,
                        linkWithAccreditation: [],
                    }
                }
            }
        case 'GRID_SORT':
            const grid = GridReducer(state[action.id], action);
            const gridSort = getGridSort(state[action.id].filter, action);
            return {
                ...state,
                [action.id]: {
                    ...grid,
                    filter: {
                        ...grid.filter,
                        sort: gridSort
                    }
                }
            }
        case 'GRID_FETCH':
            const currentGrid = GridReducer(state[action.id], action);
            return {
                ...state,
                [action.id]: {
                    ...currentGrid,
                    filter: {
                        ...currentGrid.filter
                    },
                    items: action?.items,
                    itemsCount: action?.itemsCount
                }
            }
        case 'SHOW_LOADING':
        case 'PAGINATE':
        case 'GRID_RELOAD':
            const currentReloadGrid = GridReducer(state[action.id], action);
            return {
                ...state,
                [action.id]: {
                    ...currentReloadGrid
                }
            }
        case 'GRID_RESET_FILTER':
            return {
                ...state,
                [action.id]: GridReducer(state[action.id], action)
            }
    }

    // join pnpAccred state with module state
    if (action.type.startsWith(PNP_ACCRED_ACTION_PREFIX)
        || action.id && PNP_ACCRED_ACTION_IDS.hasOwnProperty(action.id.split('.').join('_'))) {
        return { ...state, pnpAccred: PnpAccredReducer(state.pnpAccred, action) }
    }

    return state;
}
